import { IBaseOption } from '~/utils/interface/common';
import { ICampaign } from '~/utils/interface/campaign';

export const mockDataCampaignType: IBaseOption[] = [
  {
    label: 'Before Job Starts',
    value: 'BEFORE_JOB_STARTS',
  },
  {
    label: 'After Job Completes',
    value: 'AFTER_JOB_COMPLETES',
  },
];

export const mockDataListCampaigns: ICampaign[] = [
  {
    id: '1',
    name: 'Email Social',
    type: 'BEFORE_JOB_STARTS',
  },
  {
    id: '2',
    name: 'Advertisement Noble Plumbing',
    type: 'AFTER_JOB_COMPLETES',
  },
];
